import { render, staticRenderFns } from "./etpView.vue?vue&type=template&id=27a90d10&scoped=true"
import script from "./etpView.vue?vue&type=script&lang=js"
export * from "./etpView.vue?vue&type=script&lang=js"
import style0 from "./etpView.vue?vue&type=style&index=0&id=27a90d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a90d10",
  null
  
)

export default component.exports